import { BaseService, Service } from "/@/cool";

@Service("baseAppSpaceType")
class SpaceType extends BaseService {}

export default SpaceType;
